module.exports = __webpack_public_path__ + "static/media/linkedin-round.1eb49ff5.svg";